import ThreeGridAltOverflowPattern from "@ui/components/patterns/ThreeGridAltOverflowPattern";
import ThreeGridBigPattern from "@ui/components/patterns/ThreeGridBigPattern";
import ThreeGridOverflowPattern from "@ui/components/patterns/ThreeGridOverflowPattern";
import ThreeUpAltPattern from "@ui/components/patterns/ThreeUpAltPattern";
import ThreeUpPattern from "@ui/components/patterns/ThreeUpPattern";
import { PatternSwitcherConfig } from "@ui/context/component-config-context";

const patternSwitcherConfig: PatternSwitcherConfig = {
  MobilePattern: ThreeUpPattern,
  componentContext: {
    categoryPillarThreeUp: {
      MobilePattern: ThreeUpAltPattern,
      TabletPattern: ThreeGridBigPattern,
      DesktopPattern: ThreeUpPattern,
    },
    guidesSection: {
      MobilePattern: ThreeGridOverflowPattern,
      TabletPattern: ThreeGridOverflowPattern,
      DesktopPattern: ThreeGridAltOverflowPattern,
    },
    homepageSpotlight: {
      MobilePattern: ThreeUpPattern,
      TabletPattern: ThreeGridBigPattern,
      DesktopPattern: ThreeUpPattern,
    },
  },
};

export default patternSwitcherConfig;
